import { useQuery } from "@tanstack/react-query"
import { InvitationGetResponse } from "../types/types"
import { apiFetchProtected } from "../utils/api"

const fetchInvitation = async (
  studyId: string | null | undefined
): Promise<InvitationGetResponse> => {
  if (studyId) {
    return await apiFetchProtected<InvitationGetResponse>(
      `/invitation?study=${studyId}`,
      {}
    )
  }
  return {
    invitation_token: ""
  }
}

export const useInvitation = (
  studyId: string | null | undefined,
  enabled: boolean
) =>
  useQuery({
    queryKey: ["invitation"],
    queryFn: () => fetchInvitation(studyId),
    enabled
  })
